import React from "react";
import {SaleConfirmation} from "./SaleConfirmation";
import {ProductSyncNotice} from "../../components/ProductSyncNotice";
// Components
import { OrderInfo } from "./order";
import { Catalog } from "./catalog";
import { OrderMobile } from "./orderMobile";
import "./style.css";
import { CashSaleGate } from "./cashSaleGate";

export const Commander = ({ onOpenCash }) => {
  return (
    <>
    <SaleConfirmation/>
    <ProductSyncNotice/>
    <CashSaleGate onOpenCash={onOpenCash}>
      <div className="commander-body">
        <Catalog />

        <div className="commander-order">
          <div className="order-commander-body-content">
            <OrderInfo />
          </div>
        </div>
      </div>

      <OrderMobile />
    </CashSaleGate>
    </>
  );
};
